import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, BodyText, Box, Button, Flex, Heading } from "@utilitywarehouse/hearth-react";

import PrivacyNotice from "../../components/PrivacyNotice/PrivacyWrapper";
import { ABOUT_ROUTES, PATHS } from "../../config/routeConfig";
import { useAuthContext } from "../../context/auth/useAuthContext";
import { useVulnerabilityContext } from "../../context/vulnerability/useVulnerabilityContext";
import { PrivacyNoticeAnswer } from "../../context/vulnerability/VulnerabilityContext";
import { useConfirmPageClose } from "../../hooks/useConfirmPageClose";
import useTrackVulnerabilityJourney from "../../middleware/analytics/hooks/useTrackVulnerabilityJourney";
import { checkTokenExpiryOnInterval } from "../../context/auth/Token";
import Unauthenticated from "../../components/Unauthenticated";

import { IntroductionDataTest } from "./constants";

const Introduction: React.FC = () => {
  const navigate = useNavigate();
  const { privacyNoticeAnswer } = useVulnerabilityContext();
  const { setAuthenticated, authenticated } = useAuthContext();
  const { trackVulnerabilityJourneyStarted } = useTrackVulnerabilityJourney();
  const customerSaidNo = privacyNoticeAnswer === PrivacyNoticeAnswer.No;

  useConfirmPageClose();

  useEffect(() => {
    trackVulnerabilityJourneyStarted();
  }, []);

  useEffect(() => {
    checkTokenExpiryOnInterval(authenticated, setAuthenticated);
  }, []);

  return !authenticated ? (
    <Unauthenticated />
  ) : (
    <Flex direction="column" gap="500" maxWidth="700px" marginTop="500">
      <Box>
        <Heading size="lg">
          At UW, we are fully committed to making home services as
          simple as possible so that you can get on with the important
          things in life.
        </Heading>

        <BodyText marginTop="200" paragraphSpacing>
          This is especially true when it comes to customers who may
          need a bit of extra support with their services.
        </BodyText>

        <BodyText>
          Whether it&apos;s pregnancy, disability, or a tight financial
          situation, we&apos;re here to offer you a helping hand. Simply
          answer the following questions and we&apos;ll add this information
          to your account so that we can tailor our support to your
          specific needs.
        </BodyText>
      </Box>

      <PrivacyNotice />

      {privacyNoticeAnswer !== PrivacyNoticeAnswer.No && (
        <Flex direction="column" gap="500">
          <Alert
            colorScheme="info"
            text="Please submit your answers within 1 hour of visiting
              this form, so we can best tailor our support to your
              specific needs."
          />
        </Flex>
      )}

      <Flex gap="300">
        <Button
          colorScheme="highlight"
          onClick={() =>
            navigate(`/${PATHS.About}/${ABOUT_ROUTES.Children}`)
          }
          data-testid={IntroductionDataTest.GET_STARTED_BUTTON}
          disabled={customerSaidNo || privacyNoticeAnswer === PrivacyNoticeAnswer.None}
        >
          Get started
        </Button>
      </Flex>
    </Flex>
  )
};

export default Introduction;
